import React from 'react'
import PropTypes from 'prop-types'
import { applicationStateShape } from '../../utils/shapes'
import replaceApplicationStatePlaceholders from '../../utils/replaceApplicationStatePlaceholders'
import verifyParameters from '../../utils/verifyParameters'

class Tracker extends React.Component {
  constructor(props) {
    super(props)

    this.initialized = false
    this.pageType = null

    this.getEventTypes = this.getEventTypes.bind(this)
    this.handleEvents = this.handleEvents.bind(this)
  }

  getEventTypes(firstLoad) {
    const { pageType } = this.props.applicationState

    return {
      init: firstLoad,
      pageview: firstLoad ? true : this.pageType !== pageType,
      landing: pageType === 'landing' || pageType === 'landing_flights',
      index: pageType === 'index',
      search: pageType === 'search_results' || pageType === 'search_results_flights',
      details: pageType === 'product_details',
      checkout: pageType === 'checkout_process',
      success: pageType === 'post_booking',
      others: pageType === 'others',
    }
  }

  handleEvents(firstLoad = false) {
    const { events, applicationState } = this.props

    if (!events) {
      return
    }

    Object.keys(events).forEach((eventType) => {
      // make sure the event type is valid
      if (this.getEventTypes(firstLoad)[eventType]) {
        if (this.isArrayOfEvents(events[eventType])) {
          events[eventType].forEach((event) => {
            const args = replaceApplicationStatePlaceholders(event, applicationState)
            this.callEvent(eventType, firstLoad, args)
          })
        } else {
          const args = replaceApplicationStatePlaceholders(events[eventType], applicationState)
          this.callEvent(eventType, firstLoad, args)
        }
      }
    })
  }

  isArrayOfEvents(events) {
    return Array.isArray(events) && events.length > 0 && events[0].length > 0 && Array.isArray(events[0])
  }

  callEvent(eventType, firstLoad, args) {
    // verify that we have values for all arguments
    if (verifyParameters(args)) {
      this.event(eventType, firstLoad, ...args)
    }
  }

  componentDidMount() {
    const { applicationState, onInit } = this.props

    /* istanbul ignore else  */
    if (typeof window === 'object') {
      this.init().then(() => {
        this.initialized = true
        this.handleEvents(true)
        this.pageType = applicationState.pageType
        onInit(true, this.pageType)
      })
    } else {
      onInit(false)
    }
  }

  componentDidUpdate() {
    /* istanbul ignore else  */
    if (typeof window === 'object' && this.verifyInit()) {
      const nextPageType = this.props.applicationState.pageType

      if (this.pageType !== nextPageType) {
        this.handleEvents()
        this.pageType = nextPageType
        this.props.onInit(true, this.pageType)
      }
    }
  }

  verifyInit() {
    return this.initialized
  }

  /* istanbul ignore next */
  async init() {
    // is overridden
  }

  /* istanbul ignore next */
  event() {
    // is overridden
  }

  render() {
    return null
  }
}

Tracker.defaultProps = {
  onInit: () => {},
}

Tracker.propTypes = {
  trackerName: PropTypes.string,
  events: PropTypes.object,
  applicationState: applicationStateShape,
  onInit: PropTypes.func,
}

export default Tracker
